import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Main } from '#navigators';
import { theme } from '#config';
import { ApolloProvider } from '#contexts/apollo';
import { AuthProvider } from '#contexts/auth';

export const Root = () => (
  <React.StrictMode>
    <ChakraProvider theme={theme} toastOptions={{ defaultOptions: { position: 'top-right' } }}>
      <Router>
        <AuthProvider>
          <ApolloProvider>
            <Main />
          </ApolloProvider>
        </AuthProvider>
      </Router>
    </ChakraProvider>
  </React.StrictMode>
);
